module.exports = __webpack_public_path__ + "public/SiteIcons/call.png?9fd0f06f";